module.exports = __webpack_public_path__ + "img/home.4eb76920.jpeg";